import { render, staticRenderFns } from "./pz.vue?vue&type=template&id=266073f8&scoped=true"
import script from "./pz.vue?vue&type=script&lang=js"
export * from "./pz.vue?vue&type=script&lang=js"
import style0 from "./pz.vue?vue&type=style&index=0&id=266073f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266073f8",
  null
  
)

export default component.exports